<p>Wait for the redirect..</p>
